export default __webpack_public_path__ + "d37bf1ba177d49e74d5f3c215a06fc40.png";